import React from 'react';
import { useNavigate } from 'react-router-dom';

function Navbar() {
  const navigate = useNavigate();

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white py-3 shadow-sm">
      <div className="container">
        <a className="navbar-brand" href="/">
          <img 
            src="https://lh3.googleusercontent.com/d/1VG0Squbhv2_4nXDsYwG0vkrYLAMuN8EX" 
            alt="Hola Logo" 
            width="40"
          />
          Hola!..Speaking..
        </a>

        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div id="navbarNav" className="collapse navbar-collapse">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="/#features">Features</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#how-it-works">How It Works</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#pricing">Pricing</a>
            </li>
            <li className="nav-item ms-lg-3">
              <a className="btn btn-outline-primary px-4" href="/#contact">Contact Us</a>
            </li>
           
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
